export default "__VITE_ASSET__CsMZBbwX__"